module.exports = __webpack_public_path__ + "0f588b706bee5b265f732eb7ccd53e02.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/news/jetstar/jetstar-november-2015-page-001.jpg
 ** module id = 466
 ** module chunks = 0
 **/